export type CustomerViewTabKey = 'info' | 'history';

export interface CustomerViewTab {
  key: CustomerViewTabKey;
  label: string;
}

export const CUSTOMER_VIEW_TABS: CustomerViewTab[] = [
  { key: 'info', label: 'customers.viewCustomer.tabs.info' },
  { key: 'history', label: 'customers.viewCustomer.tabs.history' },
];
